import React, { useEffect, useState } from 'react';
import AuthAPI from '../api/auth/AuthAPI';

const AuthContext = React.createContext();

const LOCAL_STORAGE_TOKEN = '__customer-info-token__';

const AuthProvider = function (props) {
    const [isAuth, setAuth] = useState(checkIfAuth());
    const isLoggingOutRef = React.useRef(false);

    useEffect(() => {
        const onExpired = () => {
            // sessie verlopen -> logout
            logout('token_expired');
        };

        window.addEventListener('custinfo:session-expired', onExpired);
        return () => window.removeEventListener('custinfo:session-expired', onExpired);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function login(token, callback) {
        // Remove stored filters
        for (const item in localStorage) {
            if (
                item.includes('__customer-info-filters_') ||
                item.includes('__customer-info-load_with_archived_') ||
                item.includes('__customer-info-sort_by_')
            ) {
                localStorage.removeItem(item);
            }
        }

        localStorage.setItem(LOCAL_STORAGE_TOKEN, token);
        setAuth(true);
        callback();
    }
    async function logout(reason = 'manual') {
        if (isLoggingOutRef.current) return;
        isLoggingOutRef.current = true;

        try {
            await AuthAPI.logout(reason);
        } catch (e) {
            // ignore
        } finally {
            localStorage.removeItem(LOCAL_STORAGE_TOKEN);
            setAuth(false);
            isLoggingOutRef.current = false;
        }
    }
    function checkIfAuth() {
        const token = getToken();
        return !!token;
    }

    function getToken() {
        return localStorage.getItem(LOCAL_STORAGE_TOKEN);
    }

    return (
        <AuthContext.Provider
            value={{
                isAuth,
                login,
                logout,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

const AuthConsumer = AuthContext.Consumer;

export { AuthProvider, AuthConsumer, AuthContext };
